import { render, staticRenderFns } from "./ConfirmJoint.vue?vue&type=template&id=81ca5e7e&scoped=true&"
import script from "./ConfirmJoint.vue?vue&type=script&lang=js&"
export * from "./ConfirmJoint.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmJoint.vue?vue&type=style&index=0&id=81ca5e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ca5e7e",
  null
  
)

export default component.exports